// extracted by mini-css-extract-plugin
export default {"factBox":"FactBoxBlock_factBox__R6OUh","yellow":"FactBoxBlock_yellow__RwR6p","titleContainer":"FactBoxBlock_titleContainer__UQL4G","icon":"FactBoxBlock_icon__Yk0gt"};